export default __webpack_public_path__ + "static/media/queenlila5.c159ba92.jpg";